import React from "react";
import "./event.style.scss";

const Event = ({ key, eventTime, eventTitle, IndexOfDay, eventNumber, date, dayOfWeek, dateString, dayClick }) => {

    return (
        <div className='challenge-details-event' key={key}>
            <div className="left">
                <div className="event-time">
                    <p>{eventTime}</p>
                </div>
                <div className="main">
                    <div className="event-title">
                        <p>{eventTitle}</p>
                    </div>
                    <div className="subtitle">
                    </div>
                </div>
            </div>
            <div className="right">
                <div className="days">
                    <div className={`day${IndexOfDay === 1 ? `-clicked` : ''}`}
                        onClick={() => dayClick(0, eventNumber, date, dayOfWeek)}
                    >
                    </div>
                    <div className={`day${IndexOfDay === 2 ? `-clicked` : ''}`}
                        onClick={() => dayClick(1, eventNumber, date, dayOfWeek)}
                    >
                    </div>
                    <div className={`day${IndexOfDay === 3 ? `-clicked` : ''}`}
                        onClick={() => dayClick(2, eventNumber, date, dayOfWeek)}
                    >
                    </div>
                    <div className={`day${IndexOfDay === 4 ? `-clicked` : ''}`}
                        onClick={() => dayClick(3, eventNumber, date, dayOfWeek)}
                    >
                    </div>
                    <div className={`day${IndexOfDay === 5 ? `-clicked` : ''}`}
                        onClick={() => dayClick(4, eventNumber, date, dayOfWeek)}
                    >
                    </div>
                    <div className={`day${IndexOfDay === 6 ? `-clicked` : ''}`}
                        onClick={() => dayClick(5, eventNumber, date, dayOfWeek)}
                    >
                    </div>
                    <div className={`day${IndexOfDay === 0 ? `-clicked` : ''}`}
                        onClick={() => dayClick(6, eventNumber, date, dayOfWeek)}
                    >
                    </div>

                </div>
                <div className="info-right">
                    <p><strong>{dayOfWeek}</strong> · {dateString}</p>
                </div>
            </div>
        </div>
    );
};

export default Event;